const menu = {
    "sim": "Sim",
    "store": "Store",
    "index": "Home",
    "overview": "Overview",
    "home": "Home",
    "supervise": "Supervise",
    "device": "Device",
    "watch": "Watch",
    "superviseTemplate": "Supervise rule",
    "superviseCenter": "Supervise Center",
    "entityTemplate": "Template setting",
    "org": "Org",
    "alarm": "Alarm",
    "alarmSetting": "Alarm setting",
    "alarmList": "Alarm list",
    "systemLog": "System log",
    "system": "System",
    "deviceModel": "Device model",
    "systemSetting": "System setting",
    "statistics": "Statistics",
    visit: 'Visit',
}
export default menu